<template>
  <ValidationProvider
    :class="[className]"
    tag="div"
    :rules="rules"
    :name="name"
    v-slot="{ errors, ariaInput, invalid }"
  >
    <v-checkbox
      :class="['checkbox__control', className, invalid ? 'field-invalid' : '']"
      :error-messages="errors[0] || ''"
      :label="label"
      :hide-details="hideDetails"
      v-bind="ariaInput"
      v-model="isChecked"
      @change="onInput"
      color="#272727"
      :readonly="readonly"
      :aria-label="ariaLabel"
    >
    </v-checkbox>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";

export default {
  name: "BaseCheckBox",
  components: {
    ValidationProvider,
  },
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
    },
    className: {
      type: String,
    },
    label: {
      type: String,
    },
    rules: {
      type: [Object, String],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: [String, Boolean],
      default: true,
    },
    ariaLabel: String,
  },
  data: () => ({
    isChecked: false,
  }),
  watch: {
    isChecked(value) {
      this.$emit("input", value, this.name);
    },
    checked(val) {
      if (val !== this.isChecked) {
        this.isChecked = val;
      }
    },
  },
  created() {
    this.isChecked = this.checked;
  },
  methods: {
    onInput(val) {
      this.$emit("change", val, this.name);
    },
  },
};
</script>
<style lang="scss">
.checkbox__control {
  display: inline-block;

  .v-input__control {
    .v-label {
      color: currentColor !important;

      &.error--text {
        color: $error !important;
      }
    }
  }

  .v-input--selection {
    &-controls__input {
      margin-left: -3px;
    }
  }
}

@media screen and (max-width: ($grid-breakpoints-md - 1)) {
  .checkbox__control {
    .v-input__control {
      .v-label {
        font-size: 18px;
      }
    }
  }
}
</style>
